import type { FunctionComponent } from 'react';

type ExecutiveSummaryProps = {
  keyFindings?: string[];
  recommendedActions?: string[];
};

export const ExecutiveSummary: FunctionComponent<ExecutiveSummaryProps> = ({
  keyFindings,
  recommendedActions,
}) => {
  if (!keyFindings?.length && !recommendedActions?.length) {
    return null;
  }

  return (
    <div className="rounded-lg border bg-white p-6 shadow-sm">
      <h2 className="text-xl font-semibold" style={{ color: '#14203D' }}>
        Executive Summary
      </h2>

      {keyFindings && keyFindings.length > 0 && (
        <div className="mt-4">
          <h3 className="font-medium text-gray-700">Key Findings</h3>
          <ul className="mt-2 list-inside list-disc space-y-1 text-gray-600">
            {keyFindings.map((finding, index) => (
              <li key={index}>{finding}</li>
            ))}
          </ul>
        </div>
      )}

      {recommendedActions && recommendedActions.length > 0 && (
        <div className="mt-4">
          <h3 className="font-medium text-gray-700">Recommended Actions</h3>
          <ul className="mt-2 list-inside list-disc space-y-1 text-gray-600">
            {recommendedActions.map((action, index) => (
              <li key={index}>{action}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
